export const useHtml = () => {
  const htmlToPlainText = (data: string | undefined) => {
    if (!data) {
      return '';
    }

    const document = new DOMParser().parseFromString(data, 'text/html');
    return (
      document.body.innerHTML
        .replaceAll(/<br\s*\/>?/gi, '\n')
        .replaceAll(/<\/p>/gi, '\n')
        .replaceAll(/<\/li>/gi, '\n')
        .replaceAll(/<\/div>/gi, '\n')
        .replaceAll(/<\/h[1-6]>/gi, '\n\n')

        // Linear-time equivalent of the original /<\/?[^>]+(>|$)/g: greedy [^>]+ always stops right
        // before '>' or at end of input, so a possessive-style '>?' matches the same strings (S8786).
        .replaceAll(/<\/?[^>]+>?/g, '')
        .trim()
    );
  };

  return { htmlToPlainText };
};
